/* LUNEXUS – Wieder-da-Benachrichtigung (snippets/lx-restock-form.liquid).
   Zeigt das Formular statt „In den Warenkorb", solange die gewählte Variante ausverkauft ist,
   und folgt dem Variantenwechsel von lx-pdp.js (liest [data-lxp-vid] + [data-lxp-variants]).
   Eintrag → APEX (JSON, CORS). Newsletter-Haken → zusätzlich natives Shopify-Kundenformular
   (/contact, form_type=customer) – Shopify verschickt dort selbst die Double-Opt-in-Mail. */
(function () {
  var box = document.querySelector('[data-lx-restock]');
  if (!box || box.dataset.lxInit) return;
  box.dataset.lxInit = '1';
  var section = box.closest('[data-lxp]') || document;
  var form = box.querySelector('[data-lx-restock-form]');
  var msg = box.querySelector('[data-lx-restock-msg]');
  var btn = form.querySelector('button[type="submit"]');
  var vjson = section.querySelector('[data-lxp-variants]');
  var variants = [];
  try { variants = vjson ? JSON.parse(vjson.textContent) : []; } catch (e) { variants = []; }
  var vidInput = section.querySelector('[data-lxp-vid]');
  var done = {};

  function currentVariant() {
    var id = vidInput ? String(vidInput.value) : String(box.dataset.variant);
    if (!variants.length) return { id: id, a: box.dataset.available === 'true', exists: true };
    /* Kombination existiert nicht → lx-pdp.js lässt vid stehen, die Auswahl passt aber zu keiner Variante */
    var sel = Array.prototype.map.call(section.querySelectorAll('.lxp-opt'), function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    var v = null;
    if (sel.length) v = variants.find(function (x) { return x.o.every(function (o, i) { return o === sel[i]; }); });
    if (!v) v = variants.find(function (x) { return String(x.id) === id; });
    if (!v) return { id: id, a: true, exists: false };
    return { id: String(v.id), a: !!v.a, exists: sel.length ? v.o.every(function (o, i) { return o === sel[i]; }) : true };
  }

  function update() {
    var v = currentVariant();
    var soldOut = v.exists && !v.a;
    box.hidden = !soldOut;
    if (section.classList) section.classList.toggle('lxrs-soldout', soldOut);
    box.dataset.variant = v.id;
    var isDone = !!done[v.id];
    box.classList.toggle('is-done', isDone);
    if (!isDone) { msg.textContent = ''; msg.className = 'lxrs__msg'; }
    else { show(done[v.id], 'ok'); }
  }

  function show(text, kind) {
    msg.textContent = text;
    msg.className = 'lxrs__msg' + (kind ? ' is-' + kind : '');
  }

  function validEmail(e) { return /^[^\s@<>()[\]\\,;:"']{1,64}@[^\s@]+\.[a-z]{2,24}$/i.test(e) && e.length <= 254; }

  function subscribeNewsletter(email) {
    var fd = new URLSearchParams();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'newsletter,restock-formular');
    return fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
      .then(function () { return true; }, function () { return false; });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = String(form.email.value || '').trim();
    var nl = !!form.newsletter.checked;
    if (!validEmail(email)) { show(box.dataset.mEmail, 'err'); form.email.focus(); return; }
    var v = currentVariant();
    btn.setAttribute('aria-busy', 'true');
    show('', '');
    fetch(box.dataset.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, variantId: v.id, productHandle: box.dataset.handle, newsletter: nl, hp: form.hp.value || '', locale: box.dataset.locale || 'de' }),
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) { return { status: res.status, data: data }; });
    }).then(function (r) {
      if (r.status === 200 && r.data && r.data.ok) {
        var text = box.dataset.mOk;
        if (nl) text += box.dataset.mOknl;
        done[v.id] = text;
        box.classList.add('is-done');
        show(text, 'ok');
        form.reset();
        if (nl) subscribeNewsletter(email);
        return;
      }
      if (r.status === 400 && r.data && r.data.error === 'invalid_email') show(box.dataset.mEmail, 'err');
      else if (r.status === 429) show(box.dataset.mMany, 'err');
      else show(box.dataset.mGen, 'err');
    }, function () {
      show(box.dataset.mNet, 'err');
    }).then(function () { btn.removeAttribute('aria-busy'); });
  });

  /* Variantenwechsel: lx-pdp.js reagiert auf 'change' – wir lesen den Zustand danach. */
  section.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-lxp-opt]')) setTimeout(update, 0);
  });
  update();
})();
